import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { motion } from "framer-motion";
import { Button } from "@mui/material";

const Feature = ({ Feature, Project, index }) => {
  const [ImgSrc, setImgSrc] = useState("");
  const storage = getStorage();

  useEffect(() => {
    const GetImage = async () => {
      try {
        const imageRef = ref(
          storage,
          `PastProjects/${Project.id}/features/${Feature.name}`,
        );
        const image = await getDownloadURL(imageRef);
        setImgSrc(image);
      } catch (error) {
        console.error("Error loading feature image:", error);
      }
    };

    GetImage();
  }, [Feature.name, Project.id, storage]);

  // Determine layout based on odd/even index
  const isEven = index % 2 === 1; // index starts from 0 → even = right text, left image

  return (
    <MKBox
      component={motion.div}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.6, delay: 0.1 }}
      sx={{
        mb: 6,
        p: 4,
        background: "white", // Glass effect background
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        borderRadius: "1.5rem",
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Grid
        container
        alignItems="center"
        spacing={{ xs: 2, md: 6 }}
        direction={isEven ? "row-reverse" : "row"}
      >
        {/* Text Section */}
        <Grid item xs={12} md={6}>
          <MKTypography
            variant="h4"
            color="white"
            mb={2}
            sx={{
              fontWeight: 700,
              background: "black",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            {Feature.name}
          </MKTypography>
          <MKTypography
            variant="body1"
            color="black"
            sx={{
              fontSize: "1.1rem",
              lineHeight: 1.8,
              opacity: 0.8,
              fontWeight: 300,
            }}
          >
            {Feature.description}
          </MKTypography>
          {Project.link && (
            <Button
              href={Project.link}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                mt: 2,
                backgroundColor: "#f1f5f9",
                color: "#0f172a",
                fontWeight: 600,
                padding: "10px 24px",
                borderRadius: "0.5rem",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#192235",
                  color: "#f1f5f9",
                },
              }}
            >
              Visit Live
            </Button>
          )}
        </Grid>

        {/* Image Section */}
        <Grid item xs={12} md={6}>
          <MKBox
            sx={{
              position: "relative",
              borderRadius: "1rem",
              overflow: "hidden",
              transition: "transform 0.3s ease",
              "&:hover": {
                transform: "scale(1.02)",
              },
            }}
          >
            <MKBox
              component="img"
              src={ImgSrc}
              alt={Feature.name}
              sx={{
                width: { xs: "100%", sm: "80%" },
                height: "auto",
                maxHeight: "400px",
                objectFit: "cover",
                display: "block",
              }}
            />
          </MKBox>
        </Grid>
      </Grid>
    </MKBox>
  );
};

export default Feature;
